import { Controller } from "@hotwired/stimulus"
import { sendFailureNotification, sendSuccessNotification } from "shared/toast_notifications"
import { getCsrfToken } from "shared/form_helpers"

// Connects to data-controller="support-toggle"
export default class extends Controller {

    static targets = ["toggle"]

    static values = {
        enabled: Boolean
    }

    async toggle() {
        const newValue = this.toggleTarget.checked

        try {
            const response = await fetch("/api/organization/update", {
                method: "PATCH",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "X-CSRF-Token": getCsrfToken()
                },
                body: JSON.stringify({ support_enabled: newValue })
            })

            if (!response.ok) {
            }

            this.enabledValue = newValue
            sendSuccessNotification(newValue ? "Support access enabled" : "Support access disabled")
        } catch (error) {
            // Revert the toggle on failure
            this.toggleTarget.checked = this.enabledValue
            sendFailureNotification(error.message)
        }
    }
}
